import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const SubscriberInput = ({ value, onChange, loyaltyValue }) => {
    const { t } = useTranslation('customer');
    const classNamePromotionalEmail =
        loyaltyValue ? 
        "m2g-customer-subscriber m2g-customer-subscriber--disabled" 
        : "m2g-customer-subscriber" 
    return (
        <div className={classNamePromotionalEmail}>
            <label
                htmlFor="m2g-customer-subscriber-checkbox"
                data-subscriber-label
                className="m2g-customer-subscriber-label"
            >
                <input
                    id="m2g-customer-subscriber-checkbox"
                    data-subscriber-checkbox
                    type="checkbox"
                    className="m2g-input"
                    checked={value}
                    onChange={e => onChange(e.target.checked)}
                />
                {t('subscriber_question')}
            </label>
        </div>
    );
};

SubscriberInput.propTypes = {
    value: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    loyaltyValue: PropTypes.bool
};

export default SubscriberInput;
